import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#464646",
      "clip-path": "url(#clip0_2743_13020)"
    }, [
      _createElementVNode("path", { d: "M9.176 9.017c-.66.62-1.048 1.519-1.048 2.582 0 2.063 1.47 3.517 3.517 3.517h3.632l1.346 1.345h-5.07c-2.84 0-4.853-1.988-4.853-4.862 0-1.487.542-2.738 1.463-3.593zM24 11.6c0 2.245-1.233 3.95-3.126 4.583a1.6 1.6 0 0 0-.215-.264l-.869-.87c1.657-.306 2.782-1.644 2.782-3.45 0-2.063-1.47-3.508-3.526-3.508h-.543c.05-.434.009-.919-.041-1.345h.684C21.979 6.745 24 8.733 24 11.6M4.401 4.245c-1.759.231-2.973 1.602-2.973 3.47 0 2.071 1.462 3.516 3.517 3.516h.552c-.059.435-.017.91.033 1.345h-.677C2.022 12.576 0 10.588 0 7.714c0-2.288 1.289-4.017 3.252-4.617zm8.323 8.32q-.136.013-.277.011h-2.84c-.26-.384-.301-1.019-.184-1.345h1.968zm4.576-4.85c0 1.427-.499 2.637-1.35 3.492l-1.015-1.017c.591-.614.937-1.471.937-2.476 0-2.055-1.47-3.509-3.517-3.509H8.953L7.609 2.86h4.838c2.832 0 4.853 1.989 4.853 4.854m-2.723.375h-1.742l-1.341-1.342.059-.003h2.832c.267.384.309 1.02.192 1.345M19.063 17.514c.25.25.66.25.902 0a.64.64 0 0 0 0-.91L4.485 1.122a.65.65 0 0 0-.918 0 .66.66 0 0 0 0 .91z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2743_13020" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v18H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }